<template>
    <fade-left-animation :element="() => $refs.section">
        <section class="restaurant-reviews-widget-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <div class="header">
                        <h2 class="heading h1">{{ title }}</h2>
                    </div>

                    <div
                        class="amplify-widget"
                        :data-token="token"
                        :data-widget-id="widgetId"
                        data-widget-type="teaser"
                    />
                </mobile-gutter>
            </b-container>
        </section>
    </fade-left-animation>
</template>

<script>
    const scriptId = 'amplify-widget-init';

    export default {
        name: 'restaurant-reviews-widget-section',

        props: {
            title: {
                type: String,
                required: true,
            },
            token: {
                type: String,
                required: true,
            },
            widgetId: {
                type: String,
                required: true,
            },
        },

        mounted() {
            if (typeof window === 'undefined') {
                return;
            }

            const existingScript = document.getElementById(scriptId);

            existingScript?.remove();

            const script = document.createElement('script');
            script.src = 'https://amplify.review-alerts.com/widget-init.js';
            script.async = true;
            script.id = scriptId;
            document.body.appendChild(script);
        },

        beforeDestroy() {
            document.getElementById(scriptId)?.remove();
        },
    };
</script>

<style lang="scss" scoped>
    .restaurant-reviews-widget-section {
        position: relative;
        padding-top: 45px;
        padding-bottom: 45px;
        overflow-x: hidden;

        @include media-breakpoint-up(md) {
            padding-top: 64px;
            padding-bottom: 64px;
        }
    }

    .header {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        justify-content: center;
    }

    .heading {
        text-align: center;
        margin: 0;
        font-size: rem(24px);

        @include media-breakpoint-up(md) {
            font-size: rem(36px);
        }
    }
</style>
